const state = {
  // apiURL: 'http://localhost:8000/api/v1',
  // serverPath: 'http://localhost:8000'
  apiURL: 'https://vs-api.samath.com.au/api/v1',
  serverPath: 'https://vs-api.samath.com.au'
  // apiURL:'https://api.novatedportal.com.au/api/v1',
  // serverPath:'https://api.novatedportal.com.au'
}

const getters = {
  //
}

const actions = {}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}
